// firestoreHelpers.ts
import { FirestoreService } from "./firestoreService";

const COLLECTION_NAME = "masterData"
const SUB_COLLECTION_DISCOUNT_REASON = "discountReason"
const SUB_COLLECTION_FOOD_CATEGORIES = "foodCategories"
const SUB_COLLECTION_PLANT_BASED = "isPlantBasedTreaty"

interface discountReasonType {
    discountReason: string[];
}

interface foodCategoryType {
    foodCategories: string[];
}

export const MasterDataService = {
    fetchSaleItemsDiscountReason: async (): Promise<string[]> => {
        try {
            const discountReason = (await FirestoreService.getDocument(COLLECTION_NAME, SUB_COLLECTION_DISCOUNT_REASON)) as discountReasonType;
            if (!discountReason) {
                return []
            }
            return discountReason.discountReason || [];
        } catch (error) {
            console.error("Error fetching discount reasons:", error);
            throw error;
        }
    },
    setSaleItemsDiscountReason: async (saleItems: string[]): Promise<void> => {
        try {
            await FirestoreService.setDocument(COLLECTION_NAME, SUB_COLLECTION_DISCOUNT_REASON, {
                discountReason: saleItems,
            } as discountReasonType)
            console.log("discount reason successfully set.");
        } catch (error) {
            console.error("Error setting discount reasons:", error);
            throw error;
        }
    },
    fetchFoodCategories: async (): Promise<string[]> => {
        try {
            const categories = (await FirestoreService.getDocument(COLLECTION_NAME, SUB_COLLECTION_FOOD_CATEGORIES)) as foodCategoryType;
            if (!categories) {
                return []
            }
            return categories.foodCategories || [];
        } catch (error) {
            console.error("Error fetching food categories:", error);
            throw error;
        }
    },
    fetchIsPlantBasedTreaty: async (): Promise<boolean> => {
        try {
            const isPlantbasedTreaty = (await FirestoreService.getDocument(COLLECTION_NAME, SUB_COLLECTION_PLANT_BASED));
            if (!isPlantbasedTreaty) {
                return false
            }
            return isPlantbasedTreaty ?? false;
        } catch (error) {
            console.error("Error fetching plant based treaty:", error);
            throw error;
        }
    },
    setFoodCategories: async (categories: string[]): Promise<void> => {
        try {
            await FirestoreService.setDocument(COLLECTION_NAME, SUB_COLLECTION_FOOD_CATEGORIES, {
                foodCategories: categories,
            } as foodCategoryType)
            console.log("food categories successfully set.");
        } catch (error) {
            console.error("Error setting food categories:", error);
            throw error;
        }
    },

    setPlantBasedTreaty: async (isPlantBased: boolean): Promise<void> => {
        try {
            await FirestoreService.setDocument(COLLECTION_NAME, SUB_COLLECTION_PLANT_BASED, {
                platBasedTreaty: isPlantBased,
            })
            console.log("plant based treaty successfully set.");
        } catch (error) {
            console.error("Error setting plant based treaty:", error);
            throw error;
        }
    },
}
